import SuperTokens from 'supertokens-web-js';
import ThirdParty from 'supertokens-web-js/recipe/thirdparty'
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import Session from 'supertokens-web-js/recipe/session';
import Passwordless from 'supertokens-web-js/recipe/passwordless'
import capacitorCookieHandler from '../utils/capacitorCookieHandler';
import {Capacitor} from '@capacitor/core';
import {SuperTokensConfig} from "supertokens-web-js/lib/build/types";
import {SocialLogin} from "@capgo/capacitor-social-login";

const superTokensProperties: Partial<SuperTokensConfig> = {}
if (Capacitor.isNativePlatform())
  superTokensProperties.cookieHandler = capacitorCookieHandler;

SuperTokens.init({
  appInfo: {
    appName: 'Torim App',
    apiDomain: import.meta.env.VITE_BACKEND_URL || 'http://localhost:3001',
  },
  clientType: Capacitor.getPlatform() === 'ios' ? 'ios' : 'web',
  recipeList: [
    ThirdParty.init({
      preAPIHook: async (context) => {
        let requestInit = context.requestInit;

        if (context.action === "THIRD_PARTY_SIGN_IN_UP") {
          const headers = {
            ...requestInit.headers,
            originPlatform: Capacitor.getPlatform()
          };
          const body = {
            ...JSON.parse(requestInit.body as string),
            userContext: {
              originPlatform: Capacitor.getPlatform()
            },
          };
          requestInit = {
            ...requestInit,
            headers,
            body: JSON.stringify(body)
          }
        }

        return {
          url: context.url,
          requestInit,
        };
      }
    }),
    EmailPassword.init(),
    Session.init({
      tokenTransferMethod: Capacitor.isNativePlatform() ? "header" : 'cookie'
    }),
    Passwordless.init(),
  ],
  ...superTokensProperties,
});

SocialLogin.initialize({
  google: {
    webClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    iOSClientId: import.meta.env.VITE_GOOGLE_IOS_CLIENT_ID,
    mode: 'online'
  }
}).then(() => {
  console.log('SocialLogin Initiated');
}).catch(e => {
  console.error(`SocialLogin failed, ${e}`);
})
